import React from 'react'
import classNames from 'classnames'
import Icon from '../Icon'
import './SidebarNavItem.less'

// default renderer
export default class SidebarNavItem extends React.Component {

  render () {
    const {label, icon, level} = this.props
    let iconEl
    if (icon) {
      let iconClasses = classNames({
        [`${icon.className}`]: icon.className
      })
      iconEl = <Icon name={`${icon.name}`} className={iconClasses || undefined} /> // undefined: to avoid passing an empty string
    }
    let itemClasses = classNames({
      'nmc-sbarnav-item': true,
      [`nmc-sbarnav-level-${level}`]: true
    })
    return (
      <div className={itemClasses}>
        {iconEl}
        <span className='nmc-sbarnav-label'>
          {label}
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SidebarNavigation/SidebarNavItem.js